import React from 'react';

import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

import Loading from '../loading';
import { makeGetConfig } from '../../lib/selector';

import * as _ from 'lodash';
import { connect } from 'react-redux';

class ChartIndex extends React.PureComponent {
  constructor(props) {
    super(props);

    this.chartComponent = React.createRef();

    this.state = {
      chartOptions: {},
      isLoading: true,
      stock: 0,
      cl: '',
    };
  }

  _mapDataToState = (dt) => {
    let openIndex,
      dataSeries = [],
      timeSeries = [],
      dataVolume = [];
    let oVol = 0;
    let j = 0;
    let bYear, bMonth, bDay, eYear, eMonth, eDay;
    const { oIndex } = this.props;
    openIndex = oIndex || dt.openIndex;

    console.log(dt, oIndex);

    dt.data.forEach((idata, i) => {
      if (i === 0) {
        oVol = idata.vol;
        let date = new Date();
        // hight chart moi da xu ly +1 vao thang
        bYear = date.getFullYear();
        bMonth = date.getMonth();
        bDay = date.getDate();
        eYear = date.getFullYear();
        eMonth = date.getMonth();
        eDay = date.getDate();
      } else if (idata.time !== null && idata.time !== 'null') {
        let h = idata.time.split(':');
        let utc = Date.UTC(bYear, bMonth, bDay, h[0], h[1]);
        let indexData = { x: utc, y: idata.cIndex };
        let volumeData = { x: utc, y: idata.vol - oVol };

        if (
          ((h[0] === '13' && h[1] === '00') ||
            (h[0] === '12' && h[1] === '59')) &&
          j === 0
        ) {
          let nullUtc1 = Date.UTC(bYear, bMonth, bDay, 11, 31);
          let nullUtc2 = Date.UTC(bYear, bMonth, bDay, 12, 59);
          let indexDataP1 = { x: nullUtc1, y: idata.cIndex };
          let indexDataV1 = { x: nullUtc1, y: 0 };
          let indexDataP2 = { x: nullUtc2, y: idata.cIndex };
          let indexDataV2 = { x: nullUtc2, y: 0 };
          timeSeries.push(nullUtc1);
          timeSeries.push(nullUtc2);
          dataSeries.push(indexDataP1);
          dataSeries.push(indexDataP2);
          dataVolume.push(indexDataV1);
          dataVolume.push(indexDataV2);
          j++;
        }
        if (idata.vol - oVol > 0) {
          if (
            timeSeries.length === 0 ||
            utc - timeSeries[timeSeries.length - 1] >= 60000
          ) {
            timeSeries.push(utc);
            dataSeries.push(indexData);
            dataVolume.push(volumeData);
            oVol = idata.vol;
          } else {
            timeSeries[timeSeries.length - 1] = utc;
            dataSeries[dataSeries.length - 1] = indexData;
            dataVolume[dataVolume.length - 1] = volumeData;
          }
        }
      }
    });
    const { cl } = this.state;
    const chartOptions = {
      chart: {
        backgroundColor: 'var(--bg_card_chart)',
      },
      title: { text: '' },
      credits: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      xAxis: {
        type: 'datetime',
        gridLineColor: 'var(--bg_card_chart)',
        gridLineWidth: 0,
        labels: {
          style: {
            color: '#8e8e8e',
            fontSize: '8px',
          },
        },
        data: timeSeries,
      },
      yAxis: [
        {
          title: { text: '' },
          gridLineColor: 'var(--bg_card_chart)',
          gridLineWidth: 1,
          labels: { enabled: false },
        },
        {
          title: { text: '' },
          opposite: true,
          max:
            dt.marketCode === '10'
              ? 15000000
              : dt.marketCode === '11'
              ? 5000000
              : 2000000,
          gridLineColor: 'var(--bg_card_chart)',
          gridLineWidth: 0,
          labels: { enabled: false },
        },
      ],
      plotOptions: {
        area: {
          animation: false,
          lineWidth: 1,
          // negativeColor: true,
          marker: {
            enabled: false,
          },
          // threshold: openIndex,
        },
        column: {
          animation: false,
          lineWidth: 1,
          borderColor: '#1BA0E1',
          marker: {
            enabled: false,
          },
          shadow: false,
          states: {
            hover: {
              lineWidth: 1,
            },
          },
          series: {
            pointWidth: 2,
          },
        },
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, cl === 'i' ? '#03ff04' : cl === 'd' ? '#ff0000' : '#FDFF12'],
              [1, 'rgba(255, 255, 255, 0)'],
            ],
          },
          lineWidth: 1,
        },
        series: {
          connectNulls: false,
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          type: 'line',
          color: '#d1af54',
          data: [
            [Date.UTC(eYear, eMonth, eDay, 9, 0), openIndex],
            [Date.UTC(eYear, eMonth, eDay, 15, 0), openIndex],
          ],
          pointInterval: 30 * 10000,
          pointStart: Date.UTC(eYear, eMonth, eDay, 9, 0),
          pointEnd: Date.UTC(eYear, eMonth, eDay, 15, 0),
          marker: {
            enabled: false,
          },
          dashStyle: 'shortdash',
          enableMouseTracking: false,
          dataLabels: {
            enabled: true,
            align: 'right',
            style: {
              color: '#B6BDCD',
              fontSize: '8px',
            },
          },
        },
        {
          type: 'column',
          name: 'Volume',
          yAxis: 1,
          color: '#26abd8',
          pointInterval: 60 * 10000,
          pointStart: Date.UTC(eYear, eMonth, eDay, 9, 0),
          pointEnd: Date.UTC(eYear, eMonth, eDay, 15, 0),
          data: dataVolume,
          selected: false,
          connectNulls: false,
          enableMouseTracking: false,
          // dataGrouping: {
          //     second: ['%A, %b %e, %H:%M:%S', '%A, %b %e, %H:%M:%S', '-%H:%M:%S']
          // }
        },
        {
          type: 'area',
          threshold: null,
          color: cl === 'i' ? '#03ff04' : cl === 'd' ? '#ff0000' : '#FDFF12',
          name: 'Giá',
          pointInterval: 60 * 10000,
          pointStart: Date.UTC(eYear, eMonth, eDay, 9, 0),
          pointEnd: Date.UTC(eYear, eMonth, eDay, 15, 0),
          data: dataSeries,
          selected: false,
          enableMouseTracking: false,
          // dataGrouping: {
          //     second: ['%A, %b %e, %H:%M:%S', '%A, %b %e, %H:%M:%S', '-%H:%M:%S']
          // }
        },
      ],
    };

    console.log(chartOptions);

    this.setState({ chartOptions, isLoading: false });
  };

  _handleLoadDataStock = (index) => {
    fetch(this.props.config.config.bs + '/getchartindexdata/' + index)
      .then((response) => response.json())
      .then((res) => {
        this._mapDataToState(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillMount() {
    let { stock, config, cl } = this.props;
    this.setState({ stock });
    this.setState({ cl });
    // console.log(config)
    if (config) {
      this._handleLoadDataStock(stock);
    }
  }

  componentDidUpdate(preProps) {
    // console.log(this.props.config)
    if (this.props.config && !_.isEqual(preProps.config, this.props.config)) {
      let { stock } = this.props;
      this._handleLoadDataStock(stock);
    }
  }

  componentWillUnmount = () => {
    if (this.chart) this.chart.destroy();

    if (this.intervalId) clearInterval(this.intervalId);
  };

  _handleReloadDataStock = () => {
    let hour = new Date().getHours();
    // console.log(hour)
    if (hour < 8 || hour >= 15) return;
    let { stock } = this.props;
    this._handleLoadDataStock(stock);
  };

  componentDidMount() {
    this.intervalId = setInterval(this._handleReloadDataStock, 5 * 60 * 1000);
  }

  updateDimensions = () => {
    this.chartComponent.current &&
      this.chartComponent.current.chart &&
      this.chartComponent.current.chart.redraw();
  };

  render() {
    const { chartOptions, isLoading } = this.state;
    if (isLoading) return <Loading />;
    return (
      <HighchartsReact
        ref={this.chartComponent}
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '118px', width: '100%' } }}
        // allowChartUpdate = {false}
      />
    );
  }
}

const makeMapStateToProps = () => {
  const getConfig = makeGetConfig();

  const mapStateToProps = (state) => {
    // console.log(state)
    return {
      config: getConfig(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(ChartIndex);
